import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid px-0" }
const _hoisted_2 = { class: "row gx-0" }
const _hoisted_3 = {
  key: 0,
  class: "col-12"
}
const _hoisted_4 = { class: "ratio ratio-4x1" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "col-12"
}
const _hoisted_7 = { class: "ratio ratio-4x1" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]


import { Swiper, SwiperSlide } from 'swiper/vue'
import useImageSever from '@/composables/useImageServer'
import 'swiper/swiper-bundle.css'
import SwiperCore, {
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard
} from 'swiper'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheSliderFull',
  props: {
    imgs: null,
    video: null
  },
  setup(__props: any) {

const props = __props as {
  imgs: { path: string }[]
  video?: string
};

SwiperCore.use([Navigation, Pagination, Mousewheel, Keyboard])



const { getPathImageServer } = useImageSever()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.video)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("video", {
                muted: "",
                src: props.video,
                autoplay: "",
                controls: "",
                class: "w-100"
              }, null, 8, _hoisted_5)
            ])
          ]))
        : _createCommentVNode("", true),
      (props.imgs.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (props.imgs.length > 1)
                ? (_openBlock(), _createBlock(_unref(Swiper), {
                    key: 0,
                    navigation: true,
                    pagination: true,
                    keyboard: true,
                    class: "mySwiper",
                    "preload-images": true
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.imgs, (img) => {
                        return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                          key: img.path
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _unref(getPathImageServer)(img.path)
                            }, null, 8, _hoisted_8)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "w-100 object-fit-cover",
                    src: _unref(getPathImageServer)(props.imgs[0].path)
                  }, null, 8, _hoisted_9))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})